export const LatLonTypes = Object.freeze({
  UNKNOWN: 0,
  EXIF: 1,
  GPS: 2,
  OTHER: 3,
});